import { useFormik } from "formik";
import moment from "moment/moment";
import React, { useState ,useEffect} from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../../components/Button";
import Dropdown from "../../components/Dropdown";
import { Input } from "../../components/Input";
import LeftSide from "../../components/LeftSide";
import ManageSlotForm from "../../components/ManageSlotForm";
import PaddingContainer from "../../components/PaddingContainer";
import PreviewImagePicker from "../../components/preview-picker";
import Textarea from "../../components/Textarea";
import Title from "../../components/Title";
import UploadAndPreviewMultipleImages from "../../components/UploadAndPreviewMultipleImages";
import { useDispatch } from "react-redux";
import {
  AddCircleIcon,
  BadmintonIcon,
  CellIcon,
  LocationIcon,
  TextIcon,
} from "../../constant";
import EditCourtManagementModal from "../../modals/CourtManagement/EditCourtManagement";
import addOrEditCourtManagementSchema from "../../schema/addOrEditCourtManagementSchema";
import useApi from "../../useApi";
import classes from "./AddCourtManagement.module.css";
import { setPageTitle,setPageLink } from "../../store/pageSlice";
// import useApi from "../../useApi";
// Create an empty slot object helper - same as in SlotsTable
const initialValues = {
  courtName: "",
  courtDescription: "",
  courtSportType: "",
  courtSlotDuration: 0,
  courtStatusId: null,
  courtMainImage: null,
  courtThumbnailImage: null,
  courtPreviewImages: [null],
  courtTimings: [],
};
const AddCourtManagement = () => {
  const dispatch = useDispatch();
  const { locations } = useSelector((state) => state?.allPreLoadedApis);
  const { addCourt } = useApi();
  const [showEditPriceModal, setShowEditPriceModal] = useState(false);
  const location = useLocation();
  const [loading, setLoading] = useState(false)
  const controlsData = [
    {
      id: 1,
      label: "Court Name",
      name: "courtName",
      placeholder: "Enter Court Name",
      leftIcon: <LeftSide icon={<BadmintonIcon className={classes.icon} />} />,
    },
    {
      id: 2,
      label: "Court Type",
      name: "courtSportType",
      placeholder: "Select Court Type",
      leftIcon: <LeftSide icon={<CellIcon className={classes.icon} />} />,
    },
    {
      id: 3,
      label: "Location",
      name: "locationId",
      placeholder: "Select Location",
      leftIcon: <LeftSide icon={<LocationIcon className={classes.icon} />} />,
    },
    {
      id: 4,
      label: "Description",
      name: "courtDescription",
      placeholder: "Enter Description",
      leftIcon: <LeftSide icon={<TextIcon className={classes.icon} />} />,
    },
  ];

  const addCourtApi = async (values) => {
    setLoading(true)
    const response = await addCourt(values);
    if (response?.data?.headers?.error === 200) {
      toast.success("Court added successfully");
      resetForm();
    } else {
      toast.error(response?.data?.headers?.message);
    }
    setLoading(false)
  };
useEffect(()=>{
   dispatch(setPageTitle("Court Management"));
    dispatch(setPageLink("/court-management"));
  },[])
  const formik = useFormik({
    initialValues,
    validationSchema: addOrEditCourtManagementSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async(values, { resetForm }) => {
      if (
        values?.courtTimings?.length == 0 ||
        values?.courtTimings?.some((slot) => slot == null)
      ) {
        toast.error("Please add at least one slot");
        return;
      }
      let noOfWeekSlotsDetail = [];
      values?.courtTimings
        ?.filter((slot) => slot !== null)
        ?.forEach((slot) => {
          console.log("SLOT__",slot)
          slot?.courtDayOfWeek?.forEach((day) => {
            noOfWeekSlotsDetail.push({
              ...slot,
              courtDayOfWeek: day,
              courtStartTime: slot.courtStartTime,
              courtEndTime: slot.courtEndTime,
              courtTimingId: null,
              courtId: null,
              active: true,
              courtMinAmount: 0,
            });
          });
        });
      const params = {
        // Format the data for submission
        courtName: values.courtName,
        courtDescription: values.courtDescription,
        courtSportType: values.courtSportType,
        courtSlotDuration: values.courtSlotDuration,
        courtStatusId: values.courtStatusId,
        courtMainImage: values.courtMainImage,
        courtThumbnailImage: values.courtThumbnailImage,
        courtStatusId: 1,
        locationId: values.locationId,
        courtPreviewImages: values.courtPreviewImages
          .filter((img) => img !== null)
          ?.map((img) => img?.companyImage),
        courtSlotDuration: 30,
        // courtTimings: noOfWeekSlotsDetail?.map((item) => ({
        //   ...item,
        //   courtDayOfWeek: item?.courtDayOfWeek?.days,
        // })),
         courtTimings: noOfWeekSlotsDetail,
      };
      // return;
      console.log("PARAMS__",params)
     await addCourtApi(params);
    },
  });

  const {
    touched,
    errors,
    values,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    validateForm,
    resetForm,
    isValidating
  } = formik;


  console.log("Values ==",values)
  const handleChangeWithTouch = (field) => (value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };

  // Format courtTimings errors for SlotsTable component
  const getFormattedTimingErrors = () => {
    if (!errors.courtTimings || !touched.courtTimings) return [];
    // If errors.courtTimings is a string (general array error), convert to array format
    if (typeof errors.courtTimings === "string") {
      return [];
    }
    // Return the array of errors
    return errors.courtTimings;
  };

  // Handle slot deletion
  const handleSlotDelete = (index) => {
    const updatedSlots = [...values.courtTimings];
    updatedSlots.splice(index, 1);
    setFieldValue("courtTimings", updatedSlots);
  };

  // Handle adding a new slot
  const handleAddSlot = () => {
    setFieldValue("courtTimings", [...values.courtTimings, null]);
  };

  // Debug errors - you can remove this in production

  console.log("errors", errors);

  // Add a new function to handle discarding changes
  const handleDiscardChanges = () => {
    // Reset the formik form to initial values
    resetForm();
    // Clear the slots array
    setFieldValue("courtTimings", []);
    // Show a confirmation toast
    toast.info("Changes discarded");
  };

  // Helper function to populate form data from either navigation state or API response
  const onSaveCourtTime = (index, time) => {
    const updatedSlots = [...values.courtTimings];
    updatedSlots[index] = {
      ...time,
      courtTimingId: time.courtTimingId || Date.now(), // Add a temporary ID if not present
      slotsData: [{
        courtDayOfWeek: time.courtDayOfWeek,
        courtTimingId: time.courtTimingId || Date.now()
      }]
    };
    setFieldValue("courtTimings", updatedSlots);
  };
  console.log("Values.courtTime", values.courtTimings);

  console.log("Errors---",errors)
  return (
    <>
      <PaddingContainer>
        <div className={classes.titleWrapper}>
          <Title title={location?.state ? "Edit Court" : "Add Court"} />
        </div>

        <section className={classes.wrapper}>
          <header>
            <h3 className={classes.formTitle}>
              Fill out the Court Information
            </h3>
          </header>

          <div className={classes.formContainer}>
            <form onSubmit={handleSubmit}>
              <Row className={classes.row}>
                <Col xs={12} md={6}>
                  <PreviewImagePicker
                    id="courtMainImage"
                    label="Upload Court Main Image"
                    name="courtMainImage"
                    onChange={(file) => setFieldValue("courtMainImage", file)}
                    value={values.courtMainImage}
                  />
                </Col>
                <Col xs={12} md={6}>
                  <PreviewImagePicker
                    id="courtThumbnailImage"
                    label="Upload Court Thumbnail"
                    name="courtThumbnailImage"
                    onChange={(file) =>
                      setFieldValue("courtThumbnailImage", file)
                    }
                    value={values.courtThumbnailImage}
                    errorText={
                      touched.courtThumbnailImage && errors.courtThumbnailImage
                    }
                  />
                </Col>

                {controlsData?.map(
                  ({ leftIcon, name, label, id, placeholder }, index) => {
                    if (name === "locationId") {
                      return (
                        <Col xs={12} md={4} key={id}>
                          <Dropdown
                            options={locations?.map((data) => ({
                              label: data?.locationName,
                              value: data?.locationId,
                            }))}
                            icon={<LeftSide icon={<LocationIcon />} />}
                            customStyle={{ gap: "4px" }}
                            inputStyle={{ paddingLeft: "0" }}
                            labelStyle={{ fontSize: "16px" }}
                            label={"Location"}
                            placeholder="Select Location"
                            value={values?.locationId}
                            onChange={handleChangeWithTouch("locationId")}
                            errorText={
                              touched?.locationId && errors?.locationId
                            }
                          />
                        </Col>
                      );
                    } else if (name === "courtDescription") {
                      return (
                        <Col xs={12} md={12} key={id}>
                          <Textarea
                            isOptional={true}
                            col={30}
                            row={100}
                            label="Court Description"
                            id="courtDescription"
                            value={values.courtDescription}
                            onChange={handleChangeWithTouch("courtDescription")}
                            placeholder="Enter Court Description"
                          />
                        </Col>
                      );
                    }

                    return (
                      <Col
                        xs={12}
                        key={id}
                        md={controlsData?.length - 1 === index ? 12 : 4}
                      >
                        <Input
                          leftIcon={leftIcon}
                          customStyle={{ gap: "15px" }}
                          inputStyle={{ paddingLeft: "0" }}
                          labelStyle={{ fontSize: "16px" }}
                          label={label}
                          placeholder={placeholder}
                          value={values?.[name]}
                          onChange={handleChangeWithTouch(name)}
                          errorText={touched?.[name] && errors?.[name]}
                        />
                      </Col>
                    );
                  }
                )}

                <Col xs={12} md={12}>
                  <UploadAndPreviewMultipleImages
                    value={values.courtPreviewImages}
                    setter={(images) =>
                      setFieldValue("courtPreviewImages", images)
                    }
                  />
                </Col>

                <Col xs={12} md={12}>
                  <div>
                    {typeof errors.courtTimings === "string" && (
                      <div className={classes.errorText}>
                        {errors.courtTimings}
                      </div>
                    )}
                  </div>

                  <div className={classes.addSlotButton}>
                    <Button
                      variant="primary"
                      onClick={handleAddSlot}
                      leftIcon={<AddCircleIcon />}
                      label={"Add Slot"}
                    />
                  </div>
                  <div className={classes.slotContainer}>
                    {values?.courtTimings?.map((slot, index) => (
                      <ManageSlotForm
                        key={index}
                        slot={slot}
                        onDelete={handleSlotDelete.bind(null, index)}
                        onSaveCourtTime={(courtTime) => {
                          onSaveCourtTime(index, courtTime);
                        }}
                      />
                    ))}
                  </div>
                </Col>
                <Col xs={12}>
                  <div className={classes.buttonWrapper}>
                    <Button
                      type="button"
                      variant="secondary"
                      className={classes.submitButton}
                      onClick={handleDiscardChanges}
                    >
                      Discard Changes
                    </Button>
                    <Button
                    disabled={isValidating || loading}
                      type="submit"
                      variant="primary"
                      className={classes.submitButton}
                    >
                      Submit
                    </Button>
                  </div>
                </Col>
              </Row>
            </form>
          </div>
        </section>
      </PaddingContainer>
      {showEditPriceModal && (
        <EditCourtManagementModal
          show={showEditPriceModal}
          setShow={setShowEditPriceModal}
          onSubmit={() => {}}
        />
      )}
    </>
  );
};

export default AddCourtManagement;
